import { Box } from '@mui/material';

import Button from '@/components/Buttons/Button';
import { useSaveApp } from '@/features/Dashboard/drawer/components/AddAppHeader/useSaveApp';
import { useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';
import type { MarketApp } from '@/features/Dashboard/types';

export const DrawerFooterButtons = ({
  createWidget,
  isValid
}: {
  createWidget: () => MarketApp | undefined;
  isValid: boolean;
}) => {
  const { handleAttemptClose } = useDrawerSteps();
  const { handleSave, isPending } = useSaveApp();

  const disabled = isPending || !isValid;

  return (
    <Box
      sx={{
        minHeight: '96px',
        width: '100%',
        backgroundColor: 'background.default',
        borderTop: '1px solid',
        borderColor: 'info.dark',
        p: 3,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        '& > *': {
          flex: 1
        }
      }}
    >
      <Button
        disabled={disabled}
        sx={{
          color: 'primary.main',
          borderColor: 'primary.main'
        }}
        variant='outlined'
        onClick={() => {
          handleAttemptClose();
        }}
      >
        Discard
      </Button>
      <Button
        disabled={disabled}
        variant='contained'
        onClick={() => {
          handleSave(createWidget());
        }}
      >
        Save
      </Button>
    </Box>
  );
};
